module.exports = __webpack_public_path__ + "static/media/stars-less-1536.9ac82014.jpg";